import { ReactElement, useEffect, useRef } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { useAutocomplete } from 'hooks/api/backend/search/search';
import { Z_INDEX } from 'styles/zIndex';

import { ModalSearchInput } from './ModalSearchInput';

type Props = {
  onSubmit?: (value: string) => void;
};

export const ModalSearchBar = ({ onSubmit }: Props): ReactElement => {
  const { currentRefinement } = useAutocomplete();
  const inputRef = useRef<HTMLInputElement>(null);

  // Hide dropdown listeners
  useEffect(() => {
    const handleKeydown = (e: KeyboardEvent): void => {
      if (e.key === 'Escape') {
        inputRef.current?.blur();
      }
    };

    document.addEventListener('keydown', handleKeydown);

    return () => {
      document.removeEventListener('keydown', handleKeydown);
    };
  }, []);

  const handleSubmit = (): void => {
    inputRef.current?.blur();
    if (onSubmit) {
      onSubmit(currentRefinement);
    }
  };

  return (
    <Flex
      justifyContent="space-between"
      flexDirection="column"
      width="100%"
      flexGrow={1}
      maxW="580px"
      zIndex={Z_INDEX.SEARCH_BAR}
    >
      <Box width="100%" position="relative">
        <ModalSearchInput ref={inputRef} onSubmit={handleSubmit} />
      </Box>
    </Flex>
  );
};
